const sk = {
  common: {
    loading: "Načítava sa...",
    close: "Zavrieť",
    submit: "Odoslať",
    review: "recenzia",
    help: "Pomoc",
    tour: "Prehliadka",
    instructions: "Pokyny",
    language: "Jazyk",
    ok: "Dobre",
    appLoaderText:
      "Načítava sa... Prosím, počkajte, kým pripravíme vaše hodnotiace prostredie."
  },
  assessment: {
    fetchError: "Chyba pri načítavaní {{featureName}}",
    somethingWentWrong: "Niečo sa pokazilo.",
    goBackToDashboard: "Vráťte sa na informačný panel",
    confirmSubmissionTitle: "Potvrdiť odoslanie",
    scheduleIdNotFound: "Identifikátor plánu sa nenašiel",
    ongoingIdNotFound: "Prebiehajúce ID sa nenašlo",
    errorFetchingOngoingData:
      "Pri načítavaní prebiehajúcich údajov sa vyskytla chyba",
    connectionRestoredLabel: "Pripojenie obnovené.",
    connectionRestoredDescription:
      "Môžete pokračovať v spúšťaní testovacích prípadov.",
    connectionLostLabel: "Stratili sme spojenie s testovacím serverom.",
    connectionLostDescription:
      "Momentálne nebudete môcť spustiť ani overiť testovacie prípady.",
    featureNames: {
      assessment: "Hodnotenie",
      knowledgeCheck: "Kontrola znalostí"
    },
    cardStatus: {
      na: "N/A",
      toBeLaunched: "Ešte nespustené",
      expired: "Expirované",
      expiringSoon: "Čoskoro vyprší",
      ongoing: "Prebieha"
    },
    cardState: {
      draft: "Koncept",
      published: "Publikované",
      cancelled: "Zrušené",
      inreview: "V kontrole",
      readytopublish: "Pripravené na publikovanie",
      sentback: "Vrátené"
    },
    dashboard: {
      videoProctoring: "Video Proctoring",
      submitFeature: "Odoslať {{featureName}}",
      noSectionsFound: "Nenašli sa žiadne sekcie",
      expandAllSections: "Rozbaľte všetky sekcie",
      closeAllSections: "Zatvorte všetky sekcie",
      continueShapingAssessments: "Pokračujte vo formovaní svojich hodnotení",
      viewAll: "Zobraziť všetko",
      legend: {
        notStarted: "Nespustené",
        inProgress: "Prebieha",
        completed: "Dokončené"
      }
    },
    confirmModal: {
      description:
        "Po odoslaní nebudete môcť vo svojej {{featureName}} vykonávať žiadne zmeny. Pred potvrdením si prosím skontrolujte svoje odpovede. Chcete pokračovať v odosielaní?",
      lowWordCountWarning:
        "Vaša odpoveď na otázku {{questionTitle}} má menej ako 40 slov. Ak teraz odošlete hodnotenie, táto odpoveď sa neuloží.",
      videoNotSubmittedWarning:
        "Vaše nahrané video k otázke {{questionTitle}} nebolo odoslané. Odoslaním hodnotenia teraz túto odpoveď zahodíte.",
      unansweredQuestions: "Máte {{count}} nezodpovedaných otázok",
      andFlaggedQuestions: "a {{count}} označené otázky",
      failedToFinish: "Nepodarilo sa dokončiť {{featureName}}"
    },
    feedback: {
      submittedTitle: "Vaša {{featureName}} bola úspešne odoslaná!",
      submittedDescription:
        "Vaše odpovede boli odoslané. Ceníme si čas a úsilie, ktoré ste venovali vyplneniu tejto {{featureName}}!",
      resultInProgress:
        "Vypočítava sa výsledok a môže to trvať až minútu. Čakajte prosím...",
      resultReady:
        "Výsledok je pripravený! Kliknutím na tlačidlo Zobraziť výsledok ho zobrazíte.",
      resultDelayed:
        "Výpočet výsledku trvá dlhšie ako zvyčajne. Ohľadom výsledku kontaktujte administrátora.",
      showResult: "Zobraziť výsledok",
      redirectingToResult:
        "Presmerovanie na stránku s výsledkami o {{seconds}} sekúnd, ak nekliknete na tlačidlo Zobraziť výsledok",
      shareFeedbackTitle: "Podeľte sa o svoj názor",
      shareFeedbackDescription:
        "Vaše poznatky pripravujú pôdu pre rast. Poďme spolu na vyššiu úroveň!",
      errorSubmittingFeedback: "Chyba pri odosielaní spätnej väzby",
      feedbackSubmittedTitle: "Všetko pripravené, odoslaná spätná väzba!",
      feedbackSubmittedDescription:
        "Vaša spätná väzba bola odoslaná. Ďakujeme, že nám pomáhate zlepšovať {{featureName}} zážitok!",
      feedbackAlreadySubmittedTitle:
        "Všetko pripravené, spätná väzba už bola odoslaná!",
      feedbackAlreadySubmittedDescription:
        "Zdá sa, že spätnú väzbu ste už odoslali. Ďakujeme, že nám pomáhate zlepšovať {{featureName}} zážitok!"
    },
    page: {
      errorFetchingPreAssessmentData:
        "Chyba pri načítavaní údajov predbežného hodnotenia",
      connectionRestoredLabel: "Pripojenie obnovené.",
      connectionRestoredDescription: "Synchronizujú sa posledné zmeny...",
      offlineLabel: "Zdá sa, že ste offline.",
      offlineDescription:
        "Zmeny sa nebudú synchronizovať, kým sa znova nepripojíte"
    },
    question: {
      questions: "Otázky",
      closeQuestionsPanel: "Zavrieť panel otázok",
      collapse: "kolaps",
      sectionSummary: "Zhrnutie sekcie",
      sections: "Sekcie",
      toggleQuestionsPanel: "Prepnúť panel otázok",
      switchModal: {
        switchQuestionButton: "Prepnúť otázku",
        leaveHeading: "Naozaj chcete odísť?",
        discardMessage:
          "Máte neuložené zmeny. Ak zmeníte otázku, vaša odpoveď bude natrvalo vymazaná.",
        saveChangesButton: "Uložiť zmeny",
        saveHeading: "Chcete uložiť zmeny?",
        saveBeforeSwitchMessage:
          "Máte neuložené zmeny. Chcete ich uložiť pred zmenou otázky?"
      }
    },
    faq: {
      q1: {
        question: "Čo mám urobiť pred spustením {{featureName}}?",
        firstSentence: "Uistite sa, že ste vykonali nasledujúce kroky:",
        list: {
          item1: "Stabilné internetové pripojenie",
          item2:
            "funkčná webová kamera a mikrofón (ak je povolené zobrazovanie videa)",
          item3: "Tiché prostredie bez rušivých vplyvov",
          item4:
            "Ak je povolená úprava videa, zobrazí sa výzva na dokončenie kontroly systému.",
          item5: "Prečítajte si a vyjadrite súhlas so zmluvnými podmienkami"
        }
      },
      q2: {
        question:
          "Môžem počas {{featureName}} prechádzať medzi otázkami alebo sekciami?",
        firstSentence: "Navigácia závisí od nastavení.",
        list: {
          item1:
            "Ak je aktivovaná navigácia po sekciách, môžete sa presúvať medzi sekciami.",
          item2:
            "Ak je zakázaná, pred prechodom na ďalšiu budete musieť dokončiť jednu sekciu."
        },
        lastSentence: "Pokyny budú dostupné vždy počas {{featureName}}."
      },
      q3: {
        question: "Budem počas testu sledovaný?",
        list: {
          item1:
            "Ak má táto maska ​​{{featureName}} povolenú ochranu videa, použije sa vaša kamera a mikrofón.",
          item2: "Akákoľvek nezvyčajná aktivita môže byť označená na kontrolu."
        }
      },
      q4: {
        question:
          "Čo sa stane, ak stratím internetové pripojenie alebo omylom zatvorím prehliadač?",
        firstSentence: "Váš postup sa automaticky uloží.",
        lastSentence:
          "Ak dôjde k odpojeniu, môžete sa znova pripojiť k {{featureName}} pomocou rovnakého odkazu."
      },
      q5: {
        question: "Uvidím svoje výsledky alebo spätnú väzbu po teste?",
        firstSentence:
          "Výsledky a spätnú väzbu konfiguruje organizátor {{featureName}}.",
        list: {
          item1:
            "Ak je povolená, po odoslaní uvidíte svoje skóre a súhrn spätnej väzby.",
          item2:
            "Ak nie, vaše výsledky budú zdieľané prostredníctvom vášho registrovaného e-mailu."
        }
      }
    },
    labels: {
      totalDuration: "Celkové trvanie",
      numberOfQuestions: "Počet otázok",
      numberOfSections: "Počet sekcií",
      guidelines: "Usmernenia",
      platformHelp: "Pomocník platformy",
      faq: "FAQ",
      frequentlyAskedQuestions: "Často kladené otázky",
      showFeatureInstructions: "Zobraziť {{featureName}} pokyny",
      minutes: "minút",
      welcome: "Vitajte",
      welcomeBack: "Vitajte späť",
      userFallback: "Používateľ",
      defaultGuidelines:
        "Pred spustením {{featureName}} sa uistite, že ste v tichom priestore bez rušivých vplyvov so stabilným internetovým pripojením. Počas testu majte zapnutý fotoaparát a spravujte svoj čas rozumne, pretože existuje časový limit. Ak narazíte na akékoľvek technické problémy, okamžite kontaktujte podporu. Po dokončení skontrolujte svoje odpovede pred odoslaním. Veľa šťastia!"
    },
    zoom: {
      textSize: "Veľkosť textu:",
      decreaseTextSize: "Zmenšiť veľkosť textu (A-)",
      resetTextSize: "Obnoviť veľkosť textu (A)",
      increaseTextSize: "Zväčšiť veľkosť textu (A+)",
      decreaseInterfaceSize: "Znížte veľkosť rozhrania",
      resetInterfaceSize: "Obnoviť veľkosť rozhrania",
      increaseInterfaceSize: "Zvýšte veľkosť rozhrania"
    },
    wrapper: {
      warningTitle: "POZOR!",
      stayOnPageMessage:
        "Zostaňte na tejto stránke, kým nevyplníte {{featureName}}.",
      iUnderstand: "Rozumiem",
      submitTheFeature: "Odoslať {{featureName}}",
      videoProctoringInterrupted: "Spracovanie videa bolo prerušené",
      continuationBlocked:
        "Pokračovanie hodnotenia je zablokované, kým sa neobnoví zabezpečená ochrana videa.",
      retryProctoring: "Opätovne skúste Proctoring"
    },
    progress: {
      proceed: "Pokračujte",
      resumeFeature: "Pokračovať v {{featureName}}",
      timeRemainingMessage:
        "zostávajúce v {{featureName}}. Kliknite nižšie a pokračujte tam, kde ste prestali.",
      continueOnThisDevice: "Pokračovať v tomto zariadení?",
      switchToThisTab: "Prepnúť na túto kartu?",
      continueYourAssessmentHere: "Chcete pokračovať v hodnotení tu?",
      switchHere: "Tu prepnite",
      attemptsUnlimited:
        "Pre toto hodnotenie máte k dispozícii neobmedzený počet pokusov.",
      attemptsSingle:
        "Na tento test máte k dispozícii <strong>1</strong> pokus.",
      attemptsMultiple:
        "Pre toto hodnotenie máte k dispozícii <strong>{{remainingAttempts}}</strong> z <strong>{{maxAttempts}}</strong> pokusov.",
      coolOffAfterAttempt:
        "Po každom pokuse budete musieť počkať <strong>{{coolOffTime}}</strong>, kým začnete s ďalším pokusom."
    },
    loginWindow: {
      expiredTitle: "Čas prihlásenia vypršal",
      expiredMessage:
        "Prihlasovacie okno pre túto {{featureName}} je teraz zatvorené. Zmeškali ste povolený čas na prístup k testu."
    },
    coding: {
      saving: "Ukladanie",
      offlineTitle: "Zdá sa, že ste offline",
      offlineDescription:
        "Zmeny sa nebudú synchronizovať, kým sa znova nepripojíte",
      connectionRestored: "Spojenie obnovené",
      syncingLatest: "Synchronizujú sa posledné zmeny...",
      autoSaveEnabled: "Automatické ukladanie zapnuté",
      runOnlyChecksDescription:
        "iba kontroluje váš kód pomocou testovacích prípadov.",
      submitEvaluationDescription: "svoj kód na vyhodnotenie a získanie bodov.",
      reset: "Resetovať",
      run: "Spustiť",
      runTests: "Prebiehajúce testy",
      submit: "Odoslať",
      submitting: "Odovzdáva sa",
      resetCode: "Resetovať kód",
      resetCodeMessage:
        "Naozaj chcete vykonať reset? Tým sa odstráni celý váš aktuálny kód a obnoví sa štartovací kód",
      testCases: "Testovacie prípady",
      testCase: "Testovací prípad {{index}}",
      testCasePassed: "Testovací prípad prebehol úspešne",
      testCaseFailed: "Testovací prípad zlyhal",
      runtimeError: "Runtime Error",
      timeLimitExceeded: "Časový limit prekročený",
      timeLimitExceededTitle: "Prekročený časový limit",
      timeLimitExceededDescription:
        "Váš kód nebol vykonaný v časových limitoch. Optimalizujte svoj kód.",
      input: "Vstup",
      expectedOutput: "Očakávaný výstup",
      yourOutput: "Váš výstup",
      hiddenTestCase: "Skrytý testovací prípad",
      hiddenTestCaseDescription:
        "Skryté testovacie prípady sa používajú na vyhodnotenie, či váš kód dokáže zvládnuť rôzne scenáre vrátane rohových prípadov",
      explanation: "Vysvetlenie",
      hints: "Tipy"
    },
    subjective: {
      minWordsRequired:
        "Na odoslanie odpovede je potrebných minimálne 40 slov.",
      enterYourAnswer: "Zadajte svoju odpoveď",
      submitResponse: "Odoslať odpoveď",
      submittingResponse: "Odosielanie odpovede...",
      resetAnswer: "Resetovať odpoveď",
      resetAnswerMessage:
        "Naozaj chcete vykonať reset? Vaša aktuálna odpoveď bude natrvalo odstránená.",
      retake: "Znova",
      showHint: "Zobraziť nápovedu",
      recording: "NAHRÁVANIE"
    },
    systemCheck: {
      calibrate: "Kalibrovať",
      calibrating: "Kalibrácia...",
      accessDenied: "Prístup odmietnutý",
      cameraPermissionDenied:
        "Povolenie pre kameru bolo zamietnuté. Ak chcete pokračovať, povoľte prístup k fotoaparátu v nastaveniach prehliadača.",
      errorFetchingDevices: "Chyba pri načítavaní zariadení",
      failedToStartAssessment: "Spustenie hodnotenia zlyhalo",
      unableToStartSecureProctoring:
        "Momentálne nie je možné spustiť zabezpečený proctoring. Skúste to znova.",
      unnamedCamera: "Nemenovaný fotoaparát",
      facingCalibrationIssues: "Máte problémy s kalibráciou videa?",
      lookAtCenter: "Pozrite sa na stred obrazovky a zostaňte v pokoji.",
      unableToCalibrateTitle:
        "Nedarí sa vám kalibrovať fotoaparát na nahrávanie videa?",
      statusMessages: {
        readyForCalibration:
          "Uistite sa, že vaša tvár je jasne viditeľná a vycentrovaná na obrazovke. Keď budete pripravení, začnite kliknutím na „Kalibrovať“.",
        calibratingInProgress:
          "Prebieha kalibrácia. Pokračujte v pozeraní na obrazovku.",
        calibratingTimedOut:
          "Časový limit kalibrácie fotoaparátu vypršal. Ak chcete pokračovať, obnovte svoj prehliadač.",
        preparingCameraPreview:
          "Príprava streamu kamery a sledovania tváre na kalibráciu.",
        retryRequired:
          "Nastavenie Proctoring vyžaduje vašu akciu, než budete pokračovať.",
        proctoringUnavailable:
          "Proktorovanie je momentálne nedostupné a hodnotenie sa nedá bezpečne spustiť.",
        calibrationCompleted:
          "Kalibrácia úspešná! Všetko je pripravené na spustenie hodnotenia.",
        timeoutHelp:
          "Ak sa táto správa stále zobrazuje, skontrolujte, či sa pomocou fotoaparátu alebo externej uzávierky nenachádzajú ďalšie karty/aplikácie."
      },
      failureReasons: {
        cameraPermissionDenied:
          "Povolenie fotoaparátu je zablokované. Povoľte prístup a skúste to znova.",
        cameraUnavailable:
          "Kamera je nedostupná. Skontrolujte výber zariadenia a skúste to znova.",
        facemeshInitFailed:
          "Nastavenie sledovania tváre zlyhalo. Ak chcete pokračovať, skúste to znova.",
        cocoLoadFailed:
          "Proctoring engine nie je k dispozícii. Obnovte a skúste to znova.",
        streamLostReacquireFailed:
          "Obnovenie streamu fotoaparátu zlyhalo. Opakovať proctoring.",
        calibrationInsufficientData:
          "Kalibračné vzorky boli nedostatočné. Zopakujte kalibráciu.",
        detectionCadenceUnavailable:
          "Konfigurácia časovania nie je pripravená. Skúste to znova."
      },
      calibrationInfo: {
        heading:
          "Ak chcete úspešne kalibrovať svoje video, postupujte podľa týchto krokov:",
        followUpHeading:
          "Ak problém pretrváva, postupujte podľa týchto krokov:",
        initialSteps: {
          step1: {
            title: "Zabezpečte dobré osvetlenie",
            description:
              "Posaďte sa na dobre osvetlené miesto s jasne viditeľnou tvárou. Vyhnite sa jasnému svetlu alebo oknám za vami."
          },
          step2: {
            title: "Otočte sa priamo k fotoaparátu",
            description:
              "Umiestnite svoju tvár do stredu rámu a počas kalibrácie sa pozerajte priamo do fotoaparátu."
          },
          step3: {
            title: "Vyhnite sa tmavému alebo rozmazanému pozadiu",
            description: "Uistite sa, že pozadie je jasné a nie príliš tmavé."
          },
          step4: {
            title: "Skontrolujte povolenia fotoaparátu",
            description:
              "Po zobrazení výzvy povoľte svojmu prehliadaču prístup k webovej kamere."
          },
          step5: {
            title: "Nehýbte sa a pozerajte sa na obrazovku",
            description:
              "Počas kalibrácie držte hlavu v stabilnej polohe, aby systém mohol správne rozpoznať vašu tvár."
          }
        },
        laterSteps: {
          step1: "Skúste obnoviť stránku a prekalibrovať fotoaparát.",
          step2:
            "Zatvorte ostatné aplikácie pomocou webovej kamery (napríklad Zoom alebo Teams).",
          step3:
            "Ak problém pretrváva, kontaktujte {{contactEmail}} so snímkou ​​obrazovky s chybou."
        }
      }
    },
    stepper: {
      termsAndConditions: "Zmluvné podmienky",
      agreeTerms: "Prečítal som si zmluvné podmienky a súhlasím s nimi.",
      previousStep: "Predchádzajúci krok",
      nextStep: "Ďalší krok",
      startAssessment: "Spustiť hodnotenie",
      resumeAssessment: "Pokračovať v hodnotení",
      mediaCheck: "Kontrola médií",
      systemCheck: "Kontrola systému",
      audioCheck: {
        intro:
          "Tu môžete nahrať krátke video a overiť, že kamera a mikrofón fungujú správne.",
        mediaPermissionDenied:
          "Prístup ku kamere alebo mikrofónu bol zamietnutý. Povoľte oprávnenia v nastaveniach prehliadača.",
        startRecording: "Spustiť nahrávanie",
        stopRecording: "Zastaviť nahrávanie",
        unnamedMicrophone: "Nepomenovaný mikrofón"
      },
      stepLabel: "KROK {{step}}",
      personalDetails: "Osobné údaje",
      emailId: "ID e-mailu",
      firstName: "Krstné meno",
      lastName: "Priezvisko",
      defaultTncStatement:
        "Účasťou na tomto hodnotení potvrdzujete, že spĺňate požiadavky na spôsobilosť špecifikované spoločnosťou a súhlasíte s tým, že test dokončíte nezávisle, bez externej pomoci. Posúdenie podlieha videoproctoringu a počas celej relácie musíte mať zapnutú kameru v prostredí bez rozptyľovania. Všetok obsah a materiály poskytnuté počas hodnotenia sú dôverné a nesmú sa zdieľať, reprodukovať ani distribuovať. Súhlasíte s tým, že dodržíte určený časový limit na posúdenie; neodovzdanie do termínu môže mať za následok diskvalifikáciu. Spoločnosť nezodpovedá za žiadne technické problémy súvisiace s vaším internetovým pripojením, softvérom alebo hardvérom. Osobné údaje zhromaždené počas hodnotenia budú spracované iba na účely hodnotenia a náboru v súlade so zásadami ochrany osobných údajov spoločnosti. Akýkoľvek pokus o podvádzanie, plagiát alebo iné neetické správanie povedie k okamžitej diskvalifikácii. Odoslaním svojich odpovedí potvrdzujete, že sú konečné a po odoslaní už nie je možné ich upravovať. Spoločnosť si vyhradzuje právo tieto podmienky kedykoľvek upraviť alebo aktualizovať a účastníci budú o akýchkoľvek významných zmenách informovaní.",
      okay: "Dobre"
    },
    access: {
      cancelledTitle: '"{{title}}" bola zrušená',
      cancelledDescription:
        "Toto hodnotenie už nie je aktívne a nedá sa k nemu dostať. Skontrolujte svoj informačný panel, kde nájdete ďalšie priradené alebo nadchádzajúce hodnotenia.",
      goToHome: "Prejdite na Domov",
      refreshPage: "Obnoviť stránku"
    },
    errorPage: {
      goBack: "Späť",
      raiseRequest: "Vytvoriť žiadosť",
      retryLogin: "Skúsiť prihlásenie znova",
      contactUs: "Kontaktujte nás",
      goBackToEvent: "Späť na udalosť",
      launchCourse: "Spustiť kurz",
      created: "Vytvorené",
      starts: "Začína",
      ends: "Končí",
      untitled: "Bez názvu"
    },
    sidebar: {
      home: "Domov",
      quickAccess: "Rýchly prístup",
      questionPaperAuthoring: "Tvorba testov",
      assessmentLibrary: "Knižnica hodnotení",
      scheduleInterview: "Naplánovať pohovor",
      generateQuestions: "Generovať otázky",
      roleManagement: "Správa rolí",
      logout: "Odhlásiť sa",
      noAccess: "Bez prístupu",
      noAccessWithLabel: "{{label}} (Bez prístupu)",
      noAccessToLink: "K tomuto odkazu nemáte prístup",
      expandSidebar: "Rozbaliť bočný panel",
      collapseSidebar: "Zbaliť bočný panel",
      expand: "Rozbaliť",
      collapse: "Zbaliť",
      myPreferences: "Moje preferencie"
    },
    timesUp: {
      title: "Čas hodnotenia dokončený",
      autoSubmittedMessage:
        "Časovač vypršal. Vaše odpovede boli uložené a {{featureName}} bola automaticky odoslaná."
    },
    resultCard: {
      title: "{{featureName}} Výsledky",
      score: "skóre",
      passPercentage: "Percento prechodu",
      marksAway:
        "Od certifikácie vás delí {{count}} bodov. Zamerajte sa na odporúčané oblasti a skúste to znova.",
      certificationEarned:
        "Prekročili ste certifikačné požiadavky a získali ste certifikáciu",
      congratulationsOnEarning:
        "Gratulujeme k získaniu certifikácie {{featureName}}",
      almostThereTitle: "K získaniu certifikácie ste bližšie, než si myslíte",
      certificatePassedDescription:
        "Preukázali ste znalosti a zručnosti potrebné na získanie tohto certifikátu. Nájdite si chvíľu na oslavu tohto úspechu a zdieľajte ho so svojou sieťou",
      certificateFailDescription:
        "Tento pokus ukázal príležitosti na posilnenie vašich zručností. Skontrolujte odporúčané oblasti a vráťte sa s dôverou",
      congratsImageAlt: "Gratulujem obrázok",
      almostThereImageAlt: "Takmer tam Obrázok"
    },
    sectionCard: {
      section: "oddiel",
      startSection: "Štart sekcie",
      continueSection: "Pokračovať v sekcii",
      completed: "Dokončené",
      viewSection: "Zobraziť sekciu",
      totalQuestions: "Celkový počet otázok:",
      sectionNotFound: "Sekcia sa nenašla.",
      total: "Celkom",
      flagged: "Označené"
    },
    sectionSummary: {
      totalQuestions: "Celkový počet otázok",
      completedQuestions: "Dokončené otázky",
      flaggedQuestions: "Označené otázky",
      unattemptedQuestions: "Nevyskúšané otázky",
      codingQuestions: "Otázky týkajúce sa kódovania:",
      objectiveQuestions: "Objektívne otázky:",
      goToSections: "Prejdite do sekcií",
      lowWordCountWarning:
        "Vaša odpoveď na otázku {{questionTitle}} má menej ako 40 slov. Ak sa vrátite späť do zoznamu sekcií, táto odpoveď sa zahodí.",
      videoNotSubmittedWarning:
        "Vaše nahrané video k otázke {{questionTitle}} nebolo odoslané. Ak sa vrátite späť do zoznamu sekcií, táto odpoveď sa zahodí."
    },
    objective: {
      questionCounter: "Otázka",
      marks: "Značky:",
      explanation: "Vysvetlenie",
      hints: "Tipy",
      reset: "Resetovať",
      flag: "Vlajka",
      unflag: "Zrušiť označenie",
      previous: "Predchádzajúce",
      saveAndNext: "Uložiť a ďalej",
      saveAndViewSummary: "Uložiť a zobraziť zhrnutie sekcie",
      next: "Ďalej",
      viewSectionSummary: "Zobraziť zhrnutie sekcie",
      hideExplanation: "Skryť vysvetlenie",
      showExplanation: "Zobraziť vysvetlenie",
      hintWaitTooltip: "Musíte počkať, kým uvidíte ďalšiu nápovedu",
      noHintsPendingTooltip: "Nečakajú sa žiadne rady",
      selectOptionForExplanation:
        "Výberom možnosti zobrazíte vysvetlenie vybratej možnosti"
    },
    tour: {
      shared: {
        timer:
          "Tento časovač zobrazuje zostávajúci čas pre vaše hodnotenie. Pozorne ho sledujte, aby ste sa uistili, že všetky sekcie dokončíte v stanovenom čase.",
        submit:
          "Po dokončení všetkých častí hodnotenia môžete svoju prácu odoslať kliknutím na tlačidlo „Odoslať hodnotenie“. Táto akcia dokončí vaše odpovede a po odoslaní už nebudete môcť vykonávať zmeny. Pred pokračovaním v odosielaní sa uistite, že ste si prečítali všetky svoje odpovede."
      },
      dashboard: {
        legend:
          "Legenda stavu sekcie vám pomôže pochopiť váš pokrok počas hodnotenia. Používa jasné indikátory, ktoré ukazujú, či sekcia nebola spustená, práve prebieha alebo bola dokončená. To vám umožní rýchlo posúdiť, ktoré časti si stále vyžadujú vašu pozornosť, a efektívne riadiť svoj čas.",
        sectionCard:
          "Karta sekcie poskytuje podrobný prehľad každej sekcie hodnotenia. Zobrazuje názov sekcie, jej aktuálny stav a kľúčové informácie o otázkach v rámci sekcie. To zahŕňa celkový počet otázok, počet označených otázok a počet otázok, ktoré boli dokončené. Karta sekcie vám pomôže sledovať váš pokrok a identifikovať oblasti, ktoré si môžu vyžadovať viac pozornosti."
      },
      coding: {
        titles:
          "V hornej časti stránky nájdete prehľadné zobrazenie názvu hodnotenia a názvu sekcie. To vám pomôže sledovať vašu aktuálnu úlohu a zaistí, že poznáte konkrétnu sekciu, na ktorej pracujete. Pozrite si tieto názvy, aby ste sa pri prechádzaní otázkami zorientovali.",
        sectionsButton:
          "Toto tlačidlo vám umožňuje jednoducho prejsť späť na ovládací panel sekcií. Pomocou neho sa vrátite do hlavného prehľadu vášho hodnotenia, kde si môžete prezerať a spravovať priebeh všetkých sekcií. Poskytuje rýchly spôsob, ako prehodnotiť váš celkový pokrok bez straty vašej aktuálnej práce.",
        sidebar:
          "Bočný panel poskytuje prehľad všetkých otázok v rámci aktuálnej sekcie, o ktorú sa pokúšate. Umožňuje vám rýchlo sa pohybovať medzi otázkami jednoduchým výberom príslušného bloku. Každý blok otázok je farebne odlíšený na základe jeho stavu, čo uľahčuje sledovanie vášho pokroku a prechod na konkrétne otázky podľa potreby.",
        questionCard:
          "Táto karta obsahuje otázku, na ktorej práve pracujete, zobrazuje celú výzvu a všetky relevantné pokyny alebo vstupné požiadavky. Je navrhnutý tak, aby vám poskytol jasný pohľad na danú úlohu so všetkými potrebnými informáciami, aby ste mohli pokračovať. Nájdete tu aj tlačidlo na označenie otázky na neskoršie preskúmanie, čo vám v prípade potreby umožní jednoducho sa k nej vrátiť. Okrem toho sú tu navigačné tlačidlá, ktoré vám umožňujú prejsť na nasledujúcu alebo predchádzajúcu otázku bez toho, aby ste sa vrátili na bočný panel, čím sa zaistí hladký a efektívny priebeh hodnotenia.",
        editor:
          "Editor kódu je miesto, kde budete písať a upravovať svoje riešenia. Môžete prepínať medzi rôznymi programovacími jazykmi tak, aby vyhovovali požiadavkám každej otázky. Okrem toho máte možnosť upraviť tému editora pre pohodlnejšie kódovanie. Ak dávate prednosť väčšiemu priestoru na obrazovke, editor sa dá rozšíriť na celú šírku, čím získate väčšiu plochu na prácu. Tieto funkcie sú navrhnuté tak, aby poskytovali flexibilné a užívateľsky prívetivé prostredie pri dokončení vašich úloh kódovania."
      }
    },
    toast: {
      proctoringViolationDetected: "Bolo zistené porušenie Proctoring",
      messages: {
        forbiddenObjectDetected: "Bol zistený zakázaný predmet",
        noFaceDetected: "Nebola rozpoznaná žiadna tvár",
        multipleFacesDetected: "Bolo rozpoznaných viacero tvárí",
        lookingAwayFromScreen: "Odhliadnuc od obrazovky",
        notLookingAtScreen: "Nepozerať sa na obrazovku",
        faceNotOrientedCorrectly: "Tvár nie je správne orientovaná",
        eyesNotFullyOpen: "Oči nie sú úplne otvorené",
        copyNotAllowed: "Kopírovanie nie je povolené",
        cutRestricted: "Rezanie je obmedzené v proctoring režime",
        pasteNotAllowed: "Vkladanie nie je povolené",
        contextMenuNotAllowed: "Otváranie kontextového menu nie je povolené"
      }
    },
    whatsNext: {
      heading: "Čo bude ďalej?",
      attemptsRemaining: "zostávajúcich pokusov",
      passed: {
        shareLinkedInTitle: "Zdieľať na LinkedIn",
        shareLinkedInSubtitle:
          "Oslávte svoj úspech so svojou profesionálnou sieťou.",
        viewCertificateTitle: "Zobraziť certifikát",
        viewCertificateSubtitle:
          "Stiahnite si alebo získajte prístup k svojej certifikácii kedykoľvek.",
        shareGloTitle: "Zdieľať skúsenosť",
        shareGloSubtitle:
          "Inšpirujte kolegov tým, že svoje úspechy zverejníte interne."
      },
      failed: {
        reviewLearningResourcesTitle: "Pozrite si vzdelávacie zdroje",
        reviewLearningResourcesSubtitle:
          "Posilnite zručnosť, ktorá si vyžaduje pozornosť.",
        retakeAssessmentTitle: "Zopakovať hodnotenie",
        retakeAssessmentSubtitle:
          "Ukážte svoj pokrok a aktualizované porozumenie."
      },
      modal: {
        title: "Podeľte sa o úspech",
        linkedInPostLabel: "Zdieľať na LinkedIn ako príspevok",
        linkedInProfileLabel: "Pridať ako certifikáciu do profilu LinkedIn",
        gloLabel: "Zdieľať na Glo",
        comingSoon: "Už čoskoro",
        infoMessage: "Ak chcete zdieľať, musíte byť prihlásený/-á na platforme."
      }
    },
    time: {
      hour_one: "{{count}} hodina",
      hour_other: "{{count}} hodín",
      minute_one: "{{count}} minúta",
      minute_other: "{{count}} minút",
      hourShort: "h",
      minuteShort: "min",
      secondShort: "s"
    },
    accessScreens: {
      attemptResultProcessing: {
        alt: "{{featureName}} výsledky sa spracúvajú",
        title: "Vaše výsledky sa spracúvajú",
        description:
          "Stále kontrolujeme vašu {{featureName}}. Skúste to znova čoskoro!"
      },
      coolOffPeriod: {
        alt: "Obdobie ochladzovania",
        title: "Ďalší pokus k dispozícii čoskoro",
        completedAttempt: "Pokus o to ste už dokončili",
        nextAttemptIntro: ". Váš ďalší pokus bude k dispozícii v"
      },
      maxAttemptExceeded: {
        alt: "Dosiahnutý maximálny počet pokusov",
        title: "Maximálny dosiahnutý počet pokusov",
        description:
          "Využili ste všetky dostupné pokusy pre túto {{featureName}}. Nie je možné robiť žiadne ďalšie pokusy."
      },
      scheduleNotStarted: {
        alt: "Plán sa nespustil",
        title: "{{featureName}} ešte nezačala",
        scheduledPrefix: "The",
        scheduledOn: "začiatok je naplánovaný na",
        checkBack: "Skúste to znova v {{time}} alebo obnovte, keď čas začne."
      },
      scheduleTimeCompleted: {
        alt: "Plánovaný čas dokončený",
        title: "{{featureName}} Okno zatvorené",
        description:
          "Plánovaný čas pre túto {{featureName}} uplynul. Už nemôžete spustiť ani odoslať pokus."
      }
    },
    attemptDetails: {
      allAttempts: "Všetky pokusy",
      headers: {
        attempt: "Pokus",
        attemptedOn: "Pokus o",
        percentage: "Percento"
      },
      viewAllAttempts: "Zobraziť všetky pokusy"
    },
    survey: {
      questions: {
        q1: "Na škále od 1 do 5, nakoľko jasné boli podľa vás otázky {{featureName}}?",
        q2: "Cítil som sa dostatočne pripravený na témy diskutované v {{featureName}}",
        q3: "Platforma použitá pre {{featureName}} bola užívateľsky prívetivá a funkčná",
        q4: "Verím, že moje odpovede efektívne ukázali moje schopnosti a znalosti"
      },
      stronglyDisagree: "Silne nesúhlasím",
      stronglyAgree: "Dôrazne súhlasím",
      submitFeedback: "Odoslať spätnú väzbu"
    },
    cameraPreview: {
      loadingAlt: "Načítava sa náhľad fotoaparátu",
      delayedMessage:
        "Kalibrácia trvá dlhšie, než sa očakávalo, kvôli pomalej sieti. Počkajte alebo skúste stránku obnoviť."
    },
    proctoring: {
      engineLoadFailedStatus: "Proctoring engine sa nepodarilo načítať",
      runtimeErrors: {
        cameraPermissionDenied:
          "Prístup k fotoaparátu je blokovaný nastaveniami povolení prehliadača.",
        cameraUnavailable:
          "Camera is unavailable or currently in use by another application.",
        unableToLoadModel:
          "Nepodarilo sa načítať model detekcie objektov proktorovania.",
        webglRecoveryFailed: "Obnova WebGL zlyhala pri obnove detekcie objektu."
      },
      logs: {
        engineLoadFailed: "ProctoringEngine sa nepodarilo načítať:",
        videoPlayRejected: "Video play() odmietnuté:",
        cameraTrackEnded:
          "Stopa kamery bola ukončená – pokus o opätovné získanie",
        cameraReacquired: "Fotoaparát bol znovu získaný pri pokuse {{attempt}}",
        cameraReacquireAttemptFailed:
          "Pokus o opätovné získanie fotoaparátu {{attempt}} zlyhal:",
        cameraReacquireFailedAll:
          "Opätovné získanie kamery zlyhalo po všetkých pokusoch - hlási kameru odpojenú v každom cykle",
        uploadFailedQueued:
          "Proctoring upload zlyhal po {{attempts}} pokusoch, čaká sa na opakovanie:",
        uploadAttemptFailedRetrying:
          "Pokus o načítanie {{attempt}} zlyhal, pokus sa opakuje...",
        drainedQueuedViolation:
          "Vypustené porušenie vo fronte: {{violationType}} (zostáva {{remaining}})",
        queueDrainFailed:
          "Vyprázdnenie frontu zlyhalo, zopakuje sa ďalší cyklus:",
        cocoLoadFailed: "Načítanie COCO-SSD zlyhalo:",
        faceProcessingError: "Chyba spracovania tváre:",
        errorProcessingFrame: "Chyba spracovania rámca:",
        faceMeshInitError: "Chyba inicializácie Face Mesh:"
      }
    }
  }
} as const;

export default sk;
